import SlSpinner from "@shoelace-style/shoelace/dist/components/spinner/spinner";
import { TitleWithActions } from "../titleWithActions/title-with-actions.component";
import { stylesFromStringToTag } from "@tedivo/tedivo-dom-helpers";

export class CardElement extends HTMLElement {
  public static observedAttributes = ["loading"];

  public titleHtml = "";
  public name = "";

  public intActions: HTMLElement | null = null;
  public titlePart: TitleWithActions;
  private intSpinner: SlSpinner;
  private intSpinnerHolder: HTMLElement;

  get isLoading() {
    return this.hasAttribute("loading");
  }

  set isLoading(v: boolean) {
    const hasAttr = this.hasAttribute("loading");
    if (v === hasAttr) return; // No change

    if (v) {
      this.setAttribute("loading", "");
    } else {
      this.removeAttribute("loading");
    }
  }

  get actions() {
    return this.intActions;
  }

  set actions(v: HTMLElement | null) {
    if (v === null) return;

    this.intActions = v;
    const actionsDiv = document.createElement("div");
    actionsDiv.appendChild(v);
    actionsDiv.slot = "actions";
    this.titlePart.appendChild(actionsDiv);
  }

  constructor() {
    super();
    this.titlePart = document.createElement("title-with-actions-component");
    this.intSpinner = document.createElement("sl-spinner");
    this.intSpinner.className = "card-element-spinner";
    this.intSpinnerHolder = document.createElement("div");
    this.intSpinnerHolder.style.display = "none";
  }

  connectedCallback() {
    const shadowRoot = this.attachShadow({ mode: "open" });
    const holder = document.createElement("div");
    holder.className = "card-element-holder";

    const titlePart = this.titlePart;
    titlePart.titleHtml = this.titleHtml;
    titlePart.titleNodeName = "h2";
    this.titlePart = titlePart;

    const slot = document.createElement("slot");

    holder.appendChild(titlePart);
    holder.appendChild(slot);

    this.intSpinnerHolder.className = "card-element-spinner-holder";
    this.intSpinnerHolder.appendChild(this.intSpinner);
    holder.appendChild(this.intSpinnerHolder);

    shadowRoot.appendChild(stylesFromStringToTag(styles));
    shadowRoot.appendChild(holder);
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (name === "loading") {
      if (newValue === "") {
        this.intSpinnerHolder.style.display = "block";
      } else {
        this.intSpinnerHolder.style.display = "none";
      }
    }
  }
}

customElements.define("card-element", CardElement);

declare global {
  interface HTMLElementTagNameMap {
    "card-element": CardElement;
  }
}

const styles = `
  .card-element-holder {
    background-color: var(--sl-color-neutral-0);
    border-radius: var(--sl-input-border-radius-medium);
    border: solid var(--sl-panel-border-width) var(--sl-panel-border-color);
    padding: var(--sl-spacing-large);
    margin-bottom: var(--sl-spacing-medium);
    position: relative;
  }

  .card-element-spinner-holder {
    position: absolute;
    top: 0;
    left: 0;
    background-color: var(--sl-color-neutral-100);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    pointer-events: none;
    opacity: 0.85;
  }

  .card-element-spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) ;
    
  }

  title-with-actions-component {
    display: flex;
  }
`;
